<template>
    <div class="invitacion">
        <h2 class="subheading grey--text">{{$t('Invitacion')}}</h2>

        <v-container class="my-5">
            <v-layout align-center justify-center fill-height>
                    <v-flex>
                        <v-card class="elevation-5">
                            <v-toolbar class="mb-5" dark color="primary">
                                <v-toolbar-title>
                                    {{$t('Invitacion')}}
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                            <v-card-text>
                                <v-form class="mb-4" @submit.prevent="alta_invitacion()">
                                    <v-layout row wrap>
                                        <v-flex xs12 sm4>
                                            <v-autocomplete
                                                    v-model="id_empleado"
                                                    autofocus
                                                    prepend-icon="person"
                                                    name="id_empleado"
                                                    :item-text="example"
                                                    item-value="id"
                                                    :label="$t('Empleado')"
                                                    :filter="customFilter"
                                                    :error-messages="errores.id_empleado"
                                                    :items="empleados"
                                                    no-data-text="Ningún Resultado"
                                                    clearable
                                            ></v-autocomplete>
                                        </v-flex>
                                        <v-flex xs12 sm4>
                                            <v-text-field
                                                    v-model="cell_number"
                                                    prepend-icon="phone_iphone"
                                                    name="cell_number"
                                                    :label="$t('celular')"
                                                    :error-message="errores.cell_number"
                                            >
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm4>
                                            <v-text-field
                                                    v-model="email"
                                                    prepend-icon="email"
                                                    name="email"
                                                    label="E-Mail"
                                                    :error-message="errores.email"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap>
                                        <v-flex xs12 sm6>
                                            <v-autocomplete
                                                    v-model="area"
                                                    prepend-icon="location_city"
                                                    name="area"
                                                    item-text="nombre"
                                                    item-value="id"
                                                    :label="$t('Area')"
                                                    :filter="customFilterArea"
                                                    :error-messages="errores.area"
                                                    :items="areas"
                                                    no-data-text="Ningún Resultado"
                                                    clearable
                                            ></v-autocomplete>
                                        </v-flex>
<!--                                        <v-flex xs12 sm6>-->
<!--                                            <v-menu-->
<!--                                                    v-model="calendario"-->
<!--                                                    :close-on-content-click="false"-->
<!--                                                    :nudge-right="40"-->
<!--                                                    lazy-->
<!--                                                    transition="scale-transition"-->
<!--                                                    offset-y-->
<!--                                                    full-width-->
<!--                                                    min-width="290px"-->
<!--                                            >-->
<!--                                                <template v-slot:activator="{ on }">-->
<!--                                                    <v-text-field-->
<!--                                                            v-model="date"-->
<!--                                                            prepend-icon="event"-->
<!--                                                            name="date"-->
<!--                                                            :label="$t('fecha_hora')"-->
<!--                                                            v-on="on"-->
<!--                                                            :error-messages="errores.date"-->
<!--                                                    ></v-text-field>-->
<!--                                                </template>-->
<!--                                                <v-date-picker-->
<!--                                                        v-model="date"-->
<!--                                                        locale="es-MX">-->
<!--                                                </v-date-picker>-->
<!--                                                <v-time-picker-->
<!--                                                        v-model="hora"-->
<!--                                                        @click:minute="calendario = false,-->
<!--                                                        aux = date-->
<!--                                                        date = aux + hora">-->
<!--                                                </v-time-picker>-->
<!--                                            </v-menu>-->
<!--                                        </v-flex>-->
                                        <v-flex xs12 sm6>
                                            <v-dialog
                                                    ref="dialog"
                                                    v-model="modal2"
                                                    :return-value.sync="hora"
                                                    persistent
                                                    lazy
                                                    full-width
                                                    width="290px"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                            v-model="hora"
                                                            :label="$t('fecha_hora')"
                                                            prepend-icon="access_time"
                                                            :error-messages="errores.date"
                                                            readonly
                                                            v-on="on"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                        v-model="date"
                                                        :min="get_current_date()"
                                                        :locale="$t('region')">
                                                </v-date-picker>
                                                <v-time-picker
                                                        v-if="modal2"
                                                        v-model="hora"
                                                        full-width
                                                >
                                                    <v-spacer></v-spacer>
                                                    <v-btn
                                                            flat
                                                            color="primary"
                                                            @click="modal2 = false"
                                                    >{{$t('cerrar')}}</v-btn>
                                                    <v-btn
                                                            flat
                                                            color="primary"
                                                            @click="$refs.dialog.save(hora)"
                                                    >OK</v-btn>
                                                </v-time-picker>
                                            </v-dialog>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap>
                                        <v-flex xs12 sm6>
                                            <v-textarea
                                                    v-model="business"
                                                    prepend-icon="subject"
                                                    name="business"
                                                    :placeholder="$t('placeholder_asunto')"
                                                    :label="$t('Asunto')"
                                                    :error-message="errores.business"
                                            ></v-textarea>
                                        </v-flex>
                                        <v-flex xs12 sm6>
                                            <v-label>{{ $t('mensaje_equipo') }}</v-label>
                                            <v-container fluid grid-list-sm>
                                                <v-layout row wrap>
                                                    <v-checkbox
                                                            v-for="equipo in sec_equip"
                                                            :key="equipo.id"
                                                            :value="equipo.id"
                                                            :label="equipo.nombre"
                                                    ></v-checkbox>
                                                </v-layout>
                                            </v-container>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap>
                                        <v-flex xs12 sm6>
                                            <v-label>{{ $t('mensaje_vehiculo') }}</v-label>
                                            <v-radio-group
                                                    v-model="vehicle"
                                                    prepend-icon="directions_car"
                                                    name="vehicle"
                                                    :mandatory="false"
                                                    :error-messages="errores.vehicle"
                                            >
                                                <v-radio :label="$t('Si')" value=true></v-radio>
                                                <v-radio label="No" value=false></v-radio>
                                            </v-radio-group>
                                        </v-flex>
                                        <v-flex xs12 sm6>
                                            <v-textarea
                                                    v-model="notes"
                                                    prepend-icon="notes"
                                                    name="notes"
                                                    :placeholder="$t('placeholder_notas')"
                                                    :label="$t('Notas')"
                                                    :error-message="errores.notes"
                                            ></v-textarea>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap>
                                        <v-flex xs3>
                                            <v-text-field
                                                    v-model="company"
                                                    prepend-icon="business"
                                                    name="company"
                                                    :label="$t('Empresa')"
                                                    :error-messages="errores.company"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-alert
                                            :value=alerta
                                            type="warning"
                                            outline
                                            transition="scale-transition"
                                    >
                                        Fallo con el Servidor
                                    </v-alert>
                                    <v-btn color="primary" type="submit">{{$t('enviar_codigo')}}</v-btn>
                                </v-form>

                            </v-card-text>
                        </v-card>
                    </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>
<script>
    import '@/plugins/axios'
    import store from '@/store'
    import Vue from 'vue'
    import VeeValidate from 'vee-validate'
    Vue.use(VeeValidate)

    export default {
        name: "invitacion",
        data: () => ({
            alerta: false,
            update: false,
            id_update: 0,
            nombre: '',
            activa: '',
            id_empresa: '',
            id_area: '',
            errores: [],
            search: '',
            empleados:'',
            areas:'',
            calendario: false,
            hora: '11:11',
            date:'',
            vehicle: 'false',
            sec_equip: '',
            modal2: false,
            headers: [
                {
                    text: 'Modificar',
                    align: 'left',
                    sortable: false,
                    value: 'update'
                },
                {
                    text: 'ID',
                    align: 'left',
                    sortable: true,
                    value: 'id'
                },
                {
                    text: 'Nombre',
                    align: 'left',
                    sortable: true,
                    value: 'nombre'
                },
                {
                    text: 'Activa',
                    align: 'left',
                    sortable: true,
                    value: 'activa'
                }
            ],
            casetas: []
        }),
        created: function(){
            this.get_empleados()
            this.get_areas()
            this.get_equipment()
        },
        methods: {
            example: item => item.id_usuario.first_name + ' ' + item.id_usuario.last_name +' - ' + item.id_usuario.email,
            get_empleados: function(){
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/empresas/empleados/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.empleados = response.data
                        console.log(this.empleados)
                    })
                    .catch(error => {
                        console.log(error)
                    })

            },
            get_areas: function(){
            const config = {
                method: 'get',
                url: 'https://empresa-service.intrare.app/empresas/areas/',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Token ' + store.getters.getToken
                }
            };
            axios(config)
                .then(response => {
                    this.areas = response.data
                    this.id_empresa = response.data[0].id_empresa
                    console.log(this.id_empresa)
                })
                .catch(error => {
                    console.log(error)
                })

            },
            get_equipment: function(){
            const config = {
                method: 'get',
                url: 'https://empresa-service.intrare.app/equipo_seguridad/',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Token ' + store.getters.getToken
                }
            };
            axios(config)
                .then(response => {
                    this.sec_equip = response.data
                })
                .catch(error => {
                    console.log(error)
                })

            },
            alta_invitacion: function () {
                console.log(this.date + " " + this.hora)
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        const config = {
                            method: 'post',
                            url: 'https://empresa-service.intrare.app/create_inv/',
                            headers: {
                                'Content-Type': 'application/json',
                                'authorization': 'Token ' + store.getters.getToken
                            },
                            data: {
                                nombre: this.nombre,
                                activa: this.activa,
                                id_empresa: this.id_empresa
                            }
                        };
                        axios(config)
                            .then(ok => {
                                this.$store.commit('snackbar_activate_true')
                                this.$store.commit('snackbar_change_message', 'Caseta dada de alta Correctamente.')
                                this.get_equipment()
                                this.dialog = false
                                setTimeout(this.clear, 3000);
                            })
                            .catch(error => {
                                if(error.response.status == 400
                                    && typeof error.response.data == "object"
                                    && error.response.data)
                                    this.errores = error.response.data
                            })
                    }
                }).catch((e) => {
                    console.log(e);// Failed
                });

            },
            update_caseta: function (id) {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        const config = {
                            method: 'put',
                            url: 'https://empresa-service.intrare.app/empresas/casetas/' + id +'/update/',
                            headers: {
                                'Content-Type': 'application/json',
                                'authorization': 'Token ' + store.getters.getToken
                            },
                            data: {
                                nombre: this.nombre,
                                activa: this.activa,
                                id_empresa: this.id_empresa
                            }
                        };
                        axios(config)
                            .then(ok => {
                                this.get_equipment()
                                this.$store.commit('snackbar_activate_true')
                                this.$store.commit('snackbar_change_message', 'Caseta Modificada Correctamente.')
                                this.dialog = false
                                setTimeout(this.clear, 3000);
                            })
                            .catch(error => {
                                if(error.response.status == 400
                                    && typeof error.response.data == "object"
                                    && error.response.data)
                                    this.errores = error.response.data
                            })
                    }
                }).catch((e) => {
                    console.log(e);// Failed
                });
            },
            clear: function () {
                this.alerta = false
                this.errores = []
                this.$validator.reset()
                this.$store.commit('snackbar_activate_false')
            },
            fill_fields(item){
                this.nombre = item.nombre
                this.activa = item.activa
            },
            clean_fields(){
                this.nombre = ''
                this.activa = ''
            },
            customFilter (item, queryText) {
                const textOne = item.id_usuario.first_name.toLowerCase()
                const textTwo = item.id_usuario.last_name.toLowerCase()
                const textThree = item.id_usuario.email.toLowerCase()
                const searchText = queryText.toLowerCase()
                return textOne.indexOf(searchText) > -1
                    || textTwo.indexOf(searchText) > -1
                    || textThree.indexOf(searchText) > -1

            },
            customFilterArea (item, queryText) {
                const textOne = item.nombre.toLowerCase()
                const searchText = queryText.toLowerCase()
                return textOne.indexOf(searchText) > -1
            },
            get_current_date: function (){
                var today = new Date();
                var dd = today.getDate();
                var mm = today.getMonth()+1;
                var yyyy = today.getFullYear();

                if(dd<10)
                {
                    dd='0'+dd;
                }

                if(mm<10)
                {
                    mm='0'+mm;
                }
                today = yyyy + '-' + mm + '-' + dd;
                return today
            }
        }
    }
</script>
